// FormServiceData.js
const FormServiceData = [
  "Full House Cleaning",
  "Bathroom Cleaning",
  "Kitchen Cleaning",
  "Carpet Cleaning",
  "Sofa Cleaning",
  "Mattress Cleaning",
  "Balcony Cleaning",
  "Chair Cleaning",
  "Office Cleaning",
  "Swimming Pool Cleaning",
  "Windows Cleaning",
  "Repainting",
  "Interior Painting",
  "Exterior Painting",
  "Waterproofing",
  "Grouting",
  "Wood Polishing",
  "General Pest Control",
  "Bad Bugs Pest Control",
  "Termite Pest Control",
  "Mosquito Pest Control",
  "Cockroach Pest Control",
  "Tiles/Stones Replacement",
  "Kitchen/Bathroom Remodeling",
  "Replastering",
  "Crack Filling",
  "Marble Polishing",
  "Bird Netting",
  "Residential Plumbing Service",
  "Commercial Plumbing Service",
  "Emergency Plumbing Service",
  "Residential Electrician Service",
  "Commercial Electrician Service",
  "Industrial Electrician Service",
  "Emergency Electrician Service",
  "Smart Home Electrician Service",
  "Swimming Pool Cleaning",
];

export default FormServiceData;
